import * as Sentry from '@sentry/node'
import { ELanguage } from '@microfrontends/react-components'
import { ICompanyListItem } from '../components/CompanyListPage/type'
import { DEFAULT_ERROR_CODE } from './jobService'

const COMPANY_LIST_API = `${process.env.NEXT_PUBLIC_MS_BASE_PATH}/company-profile/v1.0/company/search`
const SUGGESTION_COMPANY_API = `${process.env.NEXT_PUBLIC_MS_BASE_PATH}/hot-keywords/api/v2/keywords/suggestion-company`

export interface IMeta {
    code: number
    message: string
    nbHits?: number
    page?: number
    nbPages?: number
    hitsPerPage?: number
}
export interface ICompanyListResponse {
    data: ICompanyListItem[]
    meta: IMeta
}

export interface IPostData {
    query: string
    order: {
        field: string
        value: string
    }[]
    hitsPerPage: number
    filter: any[]
    page?: number
    ranges?: {
        field: string
        operator: string
        value: string
    }[]
    userId?: number
    regexp?: {
        field: string
        value: string
    }[]
    isJobs: boolean
}

export interface ICompanySuggestionItem {
    id: string
    type: string
    attributes: {
        isCCP: number
        companyId: number
        companyLogoUrl: string
        companyName: string
        companySlug: string
    }
}
export interface ISuggestionCompanyResponse {
    data?: ICompanySuggestionItem[]
}

export const getCompanyList = async (data: IPostData, langCode: ELanguage, accessToken: string): Promise<ICompanyListResponse> => {
    try {
        const headerParam: {
            'Content-Type': string
            'Accept-Language': string
            Authorization?: string
        } = {
            'Content-Type': 'application/json',
            'Accept-Language': langCode || ELanguage.VI
        }
        if (accessToken !== '') {
            headerParam.Authorization = `Bearer ${accessToken}`
        }
        const requestOptions = {
            method: 'POST',
            headers: headerParam,
            body: JSON.stringify(data)
        }
        const responseCompanyList = await fetch(COMPANY_LIST_API, requestOptions)
        return await responseCompanyList.json()
    } catch (ex) {
        console.error(ex)
        Sentry.captureException(ex)
        return {
            meta: {
                code: DEFAULT_ERROR_CODE,
                message: 'ERROR'
            },
            data: []
        }
    }
}

export const getCompanySuggestion = async (keyword: string, limit: number, langCode: ELanguage): Promise<ISuggestionCompanyResponse> => {
    try {
        const suggestionAPI = `${SUGGESTION_COMPANY_API}?query=${keyword}&limit=${limit}`
        const headerParam: {
            'Content-Type': string
            'Accept-Language': string
            Authorization?: string
        } = {
            'Content-Type': 'application/json',
            'Accept-Language': langCode || ELanguage.VI
        }
        const requestOptions = {
            method: 'GET',
            headers: headerParam
        }
        const responseCompanyList = await fetch(suggestionAPI, requestOptions)
        return await responseCompanyList.json()
    } catch (ex) {
        console.error(ex)
        Sentry.captureException(ex)
        return {
            data: []
        }
    }
}
